import request from '@/utils/request'

const VUE_APP_BASIC_DATA_API = process.env.VUE_APP_BASIC_DATA_API_C
// const VUE_APP_BASIC_DATA_API = 'http://10.166.2.23:3000/mock/36/'

/**
* 实名认证记录
*/
export function rnrRecord(paging) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}rnr/recordByPhone`,
    method: 'post',
    data: paging
  })
}

/**
* 实名认证记录
*/
export function rnrRecordByMeId(meid) {
  return request({
    url: `${VUE_APP_BASIC_DATA_API}rnr/recordByMeid/${meid}`,
    method: 'get'
  })
}




// WEBPACK FOOTER //
// ./src/api/user.js